


















import { Icon } from 'vant'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon
  }
})
export default class Approval extends Vue {
  @Prop() private data!: {desc: []};
  get infos () {
    return (this.data.desc || []).filter(item => typeof item === 'string').map((item: string) => {
      const [label, desc] = item.split('：')
      // console.log(label, desc)
      return {
        label,
        desc
      }
    })
  }
}
